import { DateTransform } from '@app/shared/utils/date.transform';

export class ScheduleApiModel {
  public Id: string;
  public ProgramRoleId = '';
  public AvatarSrc = '';
  public FullName = '';
  public IsDeleted = false;
  public StartDate: Date = undefined;
  public EndDate: Date = undefined;

  public serialize(data: Object): ScheduleApiModel {
    Object.assign(this, data);
    const startDate = new Date(this.StartDate);
    const endDate = new Date(this.EndDate);
    const utcStartDate = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const utcEndDate = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

    this.StartDate = new Date(utcStartDate);
    this.EndDate = new Date(utcEndDate);

    return this;
  }

  public deserialize(data: Object): ScheduleApiModel {
    Object.assign(this, data);

    this.StartDate = DateTransform.shortUTCDate(this.StartDate);
    this.EndDate = DateTransform.shortUTCDate(this.EndDate);

    return this;
  }
}
